/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { AddClientNfsShareModule } from '../add-client-nfs-share/add-client-nfs-share.module';
import { ModifyClientNfsShareModule } from '../modify-client-nfs-share/modify-client-nfs-share.module';
import { RemoveClientNfsShareModule } from '../remove-client-nfs-share/remove-client-nfs-share.module';
import { FrontTableClientNfsShareComponent } from './front-table-client-nfs-share.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        AddClientNfsShareModule,
        RemoveClientNfsShareModule,
        ModifyClientNfsShareModule,
    ],
    declarations: [FrontTableClientNfsShareComponent],
    exports: [FrontTableClientNfsShareComponent],
})
export class FrontTableClientNfsShareModule { }

